import { DATA_BINDING } from '@wix/app-definition-ids'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { AppApi } from '@wix/wix-data-client-common'
import { addOrUpdateRouterWithPattern } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { ensurePageIsLegacyIndexable } from '../ensurePageIsLegacyIndexable'
import { prepareDataForBlankPageEditor3 } from './prepareDataForBlankPageEditor3'

export const addBlankDynamicPageEditor3 = async ({
  editorSdkProxy,
  collectionsApi,
  appApi,
  collectionId,
}: {
  editorSdkProxy: EditorSDK
  collectionsApi: CollectionsApi
  appApi: AppApi
  collectionId: string
}) => {
  const schema = await collectionsApi.get(collectionId)

  const { routeDefinition, pageTitle, routerPrefix, pattern } =
    await prepareDataForBlankPageEditor3({ editorSdkProxy, appApi, schema })

  const routerRef = await addOrUpdateRouterWithPattern(
    editorSdkProxy,
    routerPrefix,
    pattern,
    routeDefinition,
  )

  const pageRef = await editorSdkProxy.routers.pages.add({
    routerRef,
    pageTitle,
    pageRoles: [routeDefinition.pageRole],
  })

  await ensurePageIsLegacyIndexable({ editorSdkProxy, pageRef })

  await editorSdkProxy.document.pages.data.update({
    pageRef,
    data: { managingAppDefId: DATA_BINDING },
  })

  await editorSdkProxy.pages.navigateTo({ pageRef })

  return {
    pageRef,
    pageUrl: `${routerPrefix}${pattern}/`,
  }
}
